import { Component, OnInit } from '@angular/core';
import { StatePersistService } from 'src/app/core/services/state-persist.service';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { HomeService } from '../../services/home.service';
import { HomeModuleConsts } from '../../constants';
import { GoogleAnalyticsService } from 'src/app/shared/services/google-analytics.service';
import { SharedConsts } from 'src/app/shared/constants';

@Component({
    selector: 'download-app',
    templateUrl: './download-app.component.html',
    styleUrls: ['./download-app.component.scss'],
    standalone: false
})
export class DownloadAppComponent implements OnInit {
  user: any;
  appLinksForm: FormGroup;
  submitted = false;
  constructor(private statePersist: StatePersistService,
    private formBuilder: FormBuilder, private homeService: HomeService,
    private googleAnalyticsService: GoogleAnalyticsService) { }

  ngOnInit(): void {
    this.user = this.statePersist.getLocalStorage('currentUser')
    this.appLinksForm = this.formBuilder.group({
      mobileNumber: ['', [Validators.required, Validators.pattern(HomeModuleConsts.UK_NUMBER)]]      
    });
  }

  iosAppEvent(){
    this.googleAnalyticsService.eventEmitter(SharedConsts.HOME_IOS_APP_DOWNLOAD_EVENT, SharedConsts.GOOGLEANALYTICSS_EVENT_CATEGORY_NAME, SharedConsts.HOME_IOS_APP_DOWNLOAD_EVENT_ACTION, SharedConsts.GOOGLEANALYTICSS_EVENT_LABEL, SharedConsts.GOOGLEANALYTICSS_EVENT_VALUE);
  }

  andriodAppevent(){
    this.googleAnalyticsService.eventEmitter(SharedConsts.HOME_ANDRIOD_APP_DOWNLOAD_EVENT, SharedConsts.GOOGLEANALYTICSS_EVENT_CATEGORY_NAME, SharedConsts.HOME_ANDRIOD_APP_DOWNLOAD_EVENT_ACTION, SharedConsts.GOOGLEANALYTICSS_EVENT_LABEL, SharedConsts.GOOGLEANALYTICSS_EVENT_VALUE);

  }

  sendSms(){
    this.submitted = true;
    if (this.appLinksForm.invalid) {
      return;
    }
    var mobile_number;
    mobile_number = this.appLinksForm.controls.mobileNumber.value
    if (mobile_number.startsWith('0')){
      mobile_number = mobile_number.replace(mobile_number.charAt(0), "+44");
    }
    this.homeService.sendSms({'user_id':this.user.id, 'phone_number': mobile_number})
      .subscribe(
        data => {
          this.appLinksForm.reset()
          this.appLinksForm.setErrors(null); 
          this.submitted = false;
        },
        error => {
          const error_object = JSON.parse(error);
          if (error_object.status === 111) {
            if (error_object.message.old_password[0] === 'Please enter correct existing password.') {
              console.log('')
            }
          }
        }
      );
  }
}
